import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const calorClaimsAuditViewRoute: RouteConfig<'with-page'> = {
    name: 'Claims Audit',
    path: '/calor/claims/audit',
    page: lazy(() => import('.')),
    roles: ['calorAdmin'],
}